<script>
    /** @type {'full'|'wide'|'narrow'} */
    export let contentAreaLayout = 'full';
</script>

<div class:content-area={contentAreaLayout !== 'full'}
    class:content-area-full={contentAreaLayout === 'full'}
    class:content-area--wide={contentAreaLayout === 'wide'}
    class:content-area--narrow={contentAreaLayout === 'narrow'}>
    {#if contentAreaLayout !== 'full'}
        <div class="content">
            <slot />
        </div>
    {:else}
        <slot />
    {/if}
</div>
